import "core-js/modules/es6.reflect.construct.js";
import _classCallCheck from "/builds/trova-cantieri/frontend/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js";
import _createClass from "/builds/trova-cantieri/frontend/node_modules/@babel/runtime-corejs2/helpers/createClass.js";
import _inherits from "/builds/trova-cantieri/frontend/node_modules/@babel/runtime-corejs2/helpers/inherits.js";
import _possibleConstructorReturn from "/builds/trova-cantieri/frontend/node_modules/@babel/runtime-corejs2/helpers/possibleConstructorReturn.js";
import _getPrototypeOf from "/builds/trova-cantieri/frontend/node_modules/@babel/runtime-corejs2/helpers/getPrototypeOf.js";
import "core-js/modules/es6.array.map.js";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
// User Model
import VuexORM from '@vuex-orm/core';
import Price from "./Price";
import Vue from 'vue';
var Product = /*#__PURE__*/function (_VuexORM$Model) {
  _inherits(Product, _VuexORM$Model);
  var _super = _createSuper(Product);
  function Product() {
    _classCallCheck(this, Product);
    return _super.apply(this, arguments);
  }
  _createClass(Product, [{
    key: "purchase",
    value: function purchase(construction, constructions) {
      if (construction) {
        return Vue.prototype.$axios.post("/api/products/".concat(this.id, "/purchase"), {
          construction_id: construction.id
        });
      }
      return Vue.prototype.$axios.post("/api/products/".concat(this.id, "/purchase"), {
        construction_list: constructions.map(function (c) {
          return c.id;
        })
      });
    }
  }], [{
    key: "entity",
    get:
    // This is the name used as module name of the Vuex Store.
    function get() {
      return 'products';
    }

    // List of all fields (schema) of the user model. `this.attr` is used
    // for the generic field type. The argument is the default value.
  }, {
    key: "fields",
    value: function fields() {
      return {
        id: this.attr(null),
        name: this.attr(null),
        description: this.attr(null),
        image_url: this.attr(null),
        default_price: this.attr(null),
        active: this.boolean(null),
        available: this.boolean(null),
        e_shop: this.boolean(null),
        platform: this.attr(null),
        options: this.attr(null),
        prices: this.hasMany(Price, 'product', 'id')
      };
    }
  }]);
  return Product;
}(VuexORM.Model);
export { Product as default };